import React from 'react';
import { Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { useStyletron } from 'baseui';

import AuthorizedRoute from '../../../../permission/AuthorizedRoute';
import { PAGE_NAMES, RESOURCES, SETTINGS_V2_ACTION } from '../../../../settingsV2Constant';

import UserList from './submodules/list';
import BulkActions from './submodules/bulkAction';

const BulkPermissionsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	const [css] = useStyletron();
	return (
		<>
			<div className={css({ height: 'calc(100% - 50px)', overflow: 'auto' })}>
				<Switch>
					<AuthorizedRoute
						exact
						configPageName={PAGE_NAMES.permissionsManagement}
						configResourceName={RESOURCES.user}
						configActionName={SETTINGS_V2_ACTION.getUsers}
						path={`${path}`}
						component={UserList}
					/>
					<AuthorizedRoute
						exact
						configPageName={PAGE_NAMES.permissionsManagement}
						configResourceName={RESOURCES.bulkPermission}
						configActionName={SETTINGS_V2_ACTION.bulkActions}
						path={`${path}/bulkActions`}
						component={BulkActions}
					/>
					<Redirect
						to={{
							pathname: '/error',
							state: { statusCode: 404, errorMsg: 'Page not found' }
						}}
					/>
				</Switch>
			</div>
		</>
	);
};

export default BulkPermissionsDashboard;
